var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"referral-free-signup-note",attrs:{"data-testid":"audience-cta-referral-note"}},[_c('li',[_vm._v(_vm._s(_vm.$t('referral_upgrade_discount_note', { percent: _vm.REFERRAL_FIRST_SUBSCRIPTION_DISCOUNT_PERCENT })))]),_c('li',[_vm._v(_vm._s(_vm.$t('referral_presenter_reward_note')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }